import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { AxlSearchBox, AxlCheckbox } from "axl-reactjs-ui";
import LazyLoad from "../../components/LazyLoad";
import moment from "moment";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import { lightTheme } from "../../themes";

// Utils

// Components
import AxlMiniGroupAssignments from "../../components/AxlMiniGroupAssignments";
import AxlMiniShipmentBox from "../../components/AxlMiniShipmentBox";

// Styles
import styles, { CheckboxContainer } from "./styles";

@inject("deliveryStore", "shipmentStore", "userStore")
@observer
class ShipmentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUnassigned: true,
      showPending: true,
      showInProgress: true,
      showCompleted: true,
      successFilter: ["ON_TIME", "EARLY", "LATE"],
    };
    this.selectShipment = this.selectShipment.bind(this);
    this.onInlineFilter = this.onInlineFilter.bind(this);
    this.onChangeSuccessFilter = this.onChangeSuccessFilter.bind(this);
  }

  componentDidMount() {
    const { deliveryStore } = this.props;
    window.onfocus = function() {
      deliveryStore.onFocus();
    };

    window.onblur = function() {
      deliveryStore.onBlur();
    };
  }

  selectShipment(s) {
    const { deliveryStore } = this.props;
    const { regions, stores, start } = deliveryStore;
    const region = regions.length > 0 ? regions.join(",") : "all";
    const day = moment(start * 1000).format("YYYY-MM-DD");
    const store = stores.length > 0 ? stores.join(",") : "";
    const storeString = !!store ? `?stores=${store}` : "";

    if (
      deliveryStore.selectedShipment &&
      deliveryStore.selectedShipment.id === s.id
    ) {
      // UNSELECT
      this.props.history.push(`/deliveries/${day}/${region}${storeString}`);
      deliveryStore.setSelectedShipment(null);
    } else {
      deliveryStore.setSelectedShipment(s);
      this.props.history.push(
        `/deliveries/${day}/${region}/${s.id}${storeString}`
      );
    }
  }

  onChangeSuccessFilter(e) {
    const { deliveryStore } = this.props;
    const { successFilter } = this.state;
    let _successFilter = successFilter;

    if (successFilter.indexOf(e.target.name) !== -1) {
      _successFilter = successFilter.filter((a) => a !== e.target.name);
    } else {
      _successFilter.push(e.target.name);
    }

    this.setState({ successFilter: _successFilter });
    deliveryStore.filterShipmentSuccess(_successFilter);
  }

  onInlineFilter(value) {
    const { deliveryStore } = this.props;
    deliveryStore.setInlineFilter(value);
  }

  render() {
    const { successFilter } = this.state;
    const { deliveryStore, userStore } = this.props;
    const {
      unrouted, pending, inprogress, succeeded, failed, exception, error,
      selectedShipment, returnedPending, returnedSuccess, inlineStats = {},
    } = deliveryStore;
    const { clientProfiles, blurCustomerInfo, blurCustomerAddress } = userStore;
    const axlMiniAssignmentBox = [
      {
        status: "UNROUTED",
        color: "#bebfc0",
        shipments: unrouted,
        length: unrouted.length,
      },
      {
        status: "PENDING",
        color: "#fbc04f",
        shipments: pending,
        length: pending.length,
      },
      {
        status: "IN PROGRESS",
        color: "#887fff",
        shipments: inprogress,
        length: inprogress.length,
      },
      {
        status: "SUCCEEDED",
        color: "#4abc4e",
        shipments: succeeded,
        length: _.defaultTo(inlineStats.succeeded, 0),
      },
      {
        status: "FAILED",
        color: "#bc4a4e",
        shipments: failed,
        length: failed.length,
      },
      {
        status: "RETURNED PENDING",
        color: "#bc4a4e",
        shipments: returnedPending,
        length: returnedPending.length,
      },
      {
        status: "RETURNED SUCCESS",
        color: "#bc4a4e",
        shipments: returnedSuccess,
        length: returnedSuccess.length,
      },
      {
        status: "EXCEPTION",
        color: "#bc4a4e",
        shipments: exception,
        length: exception.length,
      },
      {
        status: "ERRORED",
        color: "#bc4a4e",
        shipments: error,
        length: error.length,
      },
    ];
    const { late = 0, early = 0 } = inlineStats;
    const onTime = _.defaultTo(inlineStats.succeeded, 0) - late - early;
    const DEFAULT_NUMBER_SHIPMENTS_SHOW = 10;
    const DEFAULT_HEIGHT = 90;
    const LAZYLOAD_OFFSET = 1400;
    const LAZYLOAD_UNLOAD_OFFSET = 3000; // Unload items 3000px away from viewport (reduce DOM nodes)
    const MAX_TEXT_LENGTH = 23;

    return (
      <div style={styles.container}>
        <AxlSearchBox
          placeholder="Search Shipments"
          style={{ width: "100%", borderColor: lightTheme.palette.primary.main }}
          onChange={this.onInlineFilter}
        />
        <div style={styles.list} className={"momentumScroll"}>
          {axlMiniAssignmentBox.map((data, _i) => (
            <AxlMiniGroupAssignments
              key={_i}
              length={data.length}
              color={data.color}
              text={data.status}
            >
              {data.status === "SUCCEEDED" && (
                <CheckboxContainer>
                  <AxlCheckbox
                    name={`ON_TIME`}
                    checked={successFilter.indexOf("ON_TIME") !== -1}
                    theme={`secondary`}
                    color={`green`}
                    onChange={this.onChangeSuccessFilter}
                    markColor={`#FFF`}
                  >{`ON TIME (${onTime})`}</AxlCheckbox>
                  <AxlCheckbox
                    name={`EARLY`}
                    checked={successFilter.indexOf("EARLY") !== -1}
                    theme={`secondary`}
                    color={`blue`}
                    onChange={this.onChangeSuccessFilter}
                    markColor={`#FFF`}
                  >{`EARLY (${early})`}</AxlCheckbox>
                  <AxlCheckbox
                    name={`LATE`}
                    checked={successFilter.indexOf("LATE") !== -1}
                    theme={`secondary`}
                    color={`bluenight`}
                    onChange={this.onChangeSuccessFilter}
                    markColor={`#FFF`}
                  >{`LATE (${late})`}</AxlCheckbox>
                </CheckboxContainer>
              )}
              {data.shipments.map((a, idx) => {
                let height = DEFAULT_HEIGHT;
                if (a.shipment.internal_id && a.shipment.internal_id.length > MAX_TEXT_LENGTH) {
                  height += 15;
                }

                if (a.shipment.customer && a.shipment.customer.name && a.shipment.customer.name.length > MAX_TEXT_LENGTH) {
                  height += 15;
                }

                if (a.shipment.dropoff_address && a.shipment.dropoff_address.street && a.shipment.dropoff_address.street.length > MAX_TEXT_LENGTH) {
                  height += 15;
                }

                const addr = a.shipment.dropoff_address && a.shipment.dropoff_address.city +
                  ", " + a.shipment.dropoff_address.state +
                  " " + a.shipment.dropoff_address.zipcode;

                if (addr && addr.length > MAX_TEXT_LENGTH) {
                  height += 15;
                }

                if (idx < DEFAULT_NUMBER_SHIPMENTS_SHOW) {
                  return (
                    <AxlMiniShipmentBox
                      onClick={() => this.selectShipment(a.shipment)}
                      key={a.shipment.id}
                      shipment={a.shipment}
                      status={data.status}
                      clientProfile={_.find(clientProfiles, {id: a.shipment.client_profile_id})}
                      blurCustomerInfo={blurCustomerInfo}
                      blurCustomerAddress={blurCustomerAddress}
                      style={{ opacity: !selectedShipment || selectedShipment.id === a.shipment.id ? 1.0 : 0.5 }}
                      correctedAddress={a.customerProfile?.corrected_address}
                    />
                  )
                } else {
                  return (
                    <LazyLoad height={height} offset={LAZYLOAD_OFFSET} unloadOffset={LAZYLOAD_UNLOAD_OFFSET} key={a.shipment.id}>
                      <AxlMiniShipmentBox
                        onClick={() => this.selectShipment(a.shipment)}
                        shipment={a.shipment}
                        status={data.status}
                        clientProfile={_.find(clientProfiles, {id: a.shipment.client_profile_id})}
                        blurCustomerInfo={blurCustomerInfo}
                        blurCustomerAddress={blurCustomerAddress}
                        style={{ opacity: !selectedShipment || selectedShipment.id === a.shipment.id ? 1.0 : 0.5 }}
                        correctedAddress={a.customerProfile?.corrected_address}
                      />
                    </LazyLoad>
                  )
                }
              })}
            </AxlMiniGroupAssignments>
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(ShipmentList);
